import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { StickyBox } from 'components/Box'
import { PageHeader } from 'components/Header'
import Tabs, { getPage, Tab } from 'components/Tabs'
import { ROUTES } from 'routes'
import { HistoryPageTab, useTabs } from './hooks/useTabs'
import { HistoryPageUrlParams } from './hooks/useTabs/types'

export const HistoryPage = (): JSX.Element => {
  const { t } = useTranslation('features/history')
  const { tab: currentTab } = useParams<HistoryPageUrlParams>()
  const tabs: Tab<HistoryPageTab>[] = useTabs()

  return (
    <>
      <StickyBox>
        <PageHeader title={t('title')} />

        <Tabs
          path={ROUTES.HISTORY}
          tabs={tabs}
        />
      </StickyBox>

      {getPage<HistoryPageTab>(tabs, currentTab, 'builds')}
    </>
  )
}
